module.exports = __webpack_public_path__ + "b320a6c695d085f94b3d471dd337b97f.woff";